<p-panel styleClass="panel-shadow">
  <p-header>
    <div class="panel-header">Driver Details</div>
  </p-header>
  <ng-template #notAllocated>
    <div class="text-center py-3" style="font-weight: 500; color: #999">Awaiting Allocation</div>
  </ng-template>
  <div *ngIf="driverDetailsTask?.driver?.id; else notAllocated">
    <div class="grid-label-value pt-2">
      <div title="{{ driverTitle }}">Name:</div>
      <div class="value" title="{{ driverTitle }}">{{ driverName }}</div>

      <div>Licence:</div>
      <div class="value" style="word-wrap: break-word">
        {{
          driverDetailsTask?.driver
            ? driverDetailsTask?.driver?.drivingLicenceNumber || 'N/A'
            : 'N/A'
        }}
      </div>

      <div class="last-line">Mobile:</div>
      <div class="last-line value" style="word-wrap: break-word">
        <span *ngIf="!driverDetailsTask?.driver">N/A</span>
        <a
          *ngIf="driverDetailsTask?.driver"
          href="tel:{{ driverDetailsTask?.driver?.mobileNumber }}"
          >{{ driverDetailsTask?.driver?.mobileNumber || 'N/A' }}
        </a>
      </div>
    </div>
  </div>
  <div
    class="text-right"
    *ngIf="
      (organisationTypeId == OrganisationTypeEnum.Engineius ||
        organisationTypeId == OrganisationTypeEnum.Supplier) &&
      driverDetailsTask?.order?.job?.supplierId
    "
  >
    <button
      pButton
      label="Change"
      class="ui-button ui-button-secondary btn-mobile-block"
      (click)="showChangeDriverTruck()"
      [disabled]="commonService.isJobCompleted(driverDetailsTask?.order?.job)"
    ></button>
  </div>
</p-panel>

<p-dialog
  header="Change Driver/Truck"
  [(visible)]="isShowChangeDriverTruck"
  [responsive]="true"
  [modal]="true"
  [style]="{ width: '350px' }"
>
  <div class="style2023 p-3">
    <div class="input-group">
      <div class="input-group-prepend">Driver</div>
      <div class="input-group-item">
        <p-dropdown
          [options]="drivers"
          class="input-group-filter"
          placeholder="Select Driver"
          [disabled]="searchingDrivers"
          [style]="{ width: '100%' }"
          [(ngModel)]="selectedDriver"
          appendTo="body"
          filter="filter"
        ></p-dropdown>
      </div>
    </div>
    <div class="input-group mt-3">
      <div class="input-group-prepend">Truck</div>
      <div class="input-group-item">
        <p-dropdown
          [options]="trucks"
          placeholder="Select Truck"
          [disabled]="searchingTrucks"
          class="input-group-filter"
          [style]="{ width: '100%' }"
          [(ngModel)]="selectedTruck"
          appendTo="body"
          filter="filter"
        ></p-dropdown>
      </div>
    </div>
  </div>
  <p-footer>
    <div class="text-right">
      <button
        type="button"
        (click)="closeChangeDriverTruck()"
        pButton
        label="Close"
        class="ui-button ui-button-tertiary"
      ></button>
      <button
        type="button"
        pButton
        label="Save"
        class="ui-button ui-button-primary"
        (click)="SaveChangeDriverTruck()"
        [disabled]="isDriverEqual(selectedDriver) && isTruckEqual(selectedTruck)"
      ></button>
    </div>
    <div
      style="
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
        background: gray;
        opacity: 0.3;
      "
      *ngIf="searchingDrivers || searchingTrucks || isBusyChangeDriverTruck"
    >
      <img
        src="assets/images/loader.gif"
        style="margin-left: 45%; margin-top: 10%"
        width="50"
        height="50"
        alt="load"
      />
    </div>
  </p-footer>
</p-dialog>
